import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import AISendInput from 'ai-components-ui-library/components/inputs/AISendInput';
import { setAiActionsPrompt } from 'automation-ui-canvas/actions/AiAssistantActions';
import AiActionIcon from 'automation-ui-canvas/components/canvas/collaborate-generate-actions-card/components/AiActionIcon';
import FakeConnector from 'automation-ui-canvas/components/canvas/collaborate-generate-actions-card/components/FakeConnector';
import { FLOW_VIEW_ROOT } from 'automation-ui-canvas/constants/AbsolutePaths';
import CollabGenActionsFlowViewConfig from 'automation-ui-canvas/containers/flow-views/CollabGenActionsFlowViewConfig';
import { StyledActionCardHeader, StyledActionTypeHeader, StyledActionCard, StyledActionCardBody } from 'automation-ui-flow-core/canvas/AutomationBuilderCardStyles';
import { CARD_HEIGHT, CARD_WIDTH } from 'automation-ui-flow-core/canvas/graphConstants';
import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { generatePath, useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { Text } from 'foundations-components/components/Text';
import { DETAIL_MIN_ZOOM_LEVEL } from 'automation-ui-flow-core/canvas/graphConstants';
import Action from 'automation-ui-action-features/records/Action';
import { updateFlowLocally } from 'automation-ui-canvas/actions/FlowActions';
import * as ActionTypes from 'automation-ui-action-features/constants/ActionTypes';
import * as SpecialActionIds from 'automation-ui-flow-core/canvas/SpecialActionIds';
import { AIBadge } from 'ai-components-ui-library/components/informative/AIBadge';
import { useTrackEvent } from 'automation-ui-usage-tracking/usageTrackingHooks';
import Trackables from 'automation-ui-usage-tracking/Trackables';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const StyledAiActionWrapper = styled.div.withConfig({
  displayName: "CollaborateGenerateActionsNode__StyledAiActionWrapper",
  componentId: "rjqgnj-0"
})(["margin-right:10px;"]);
const StyledAiRibbon = styled.span.withConfig({
  displayName: "CollaborateGenerateActionsNode__StyledAiRibbon",
  componentId: "rjqgnj-1"
})(["position:absolute;top:8px;right:-5px;z-index:1;"]);
const StyledOverflowActionCard = styled(StyledActionCard).withConfig({
  displayName: "CollaborateGenerateActionsNode__StyledOverflowActionCard",
  componentId: "rjqgnj-2"
})(["overflow:unset;position:relative;"]);
const COPILOT_PROMPT_HEIGHT = 80;
const CollaborationGenActionsNode = ({
  edgeId,
  flow,
  flowId,
  height = CARD_HEIGHT,
  width = CARD_WIDTH,
  zoomLevel = 1
}) => {
  const layout = zoomLevel < DETAIL_MIN_ZOOM_LEVEL ? 'zoomed-out' : 'default';
  const trackEvent = useTrackEvent();
  const history = useHistory();
  const dispatch = useDispatch();
  const [prompt, setPrompt] = useState('');
  const switchToCollabMode = useCallback(() => {
    trackEvent(Trackables.CLICK_TO_GENERATE_ASSET, {
      action: 'clicked to generate actions from canvas',
      aiPrompt: prompt,
      assetType: 'AI Generated Workflow Action',
      flowId,
      destination: edgeId
    });
    const emptyAction = new Action({
      actionType: ActionTypes.EMPTY_ACTION,
      actionId: SpecialActionIds.NEW_ACTION
    });
    const newFlow = flow.insertAction({
      action: emptyAction,
      edgeId,
      actionId: SpecialActionIds.NEW_ACTION
    });
    dispatch(updateFlowLocally(newFlow));
    dispatch(setAiActionsPrompt(prompt));
    history.push({
      pathname: generatePath(FLOW_VIEW_ROOT, {
        flowId,
        viewId: CollabGenActionsFlowViewConfig.id
      }),
      search: `?edgeId=${edgeId}`
    });
  }, [history, edgeId, flowId, prompt, dispatch, flow, trackEvent]);
  const onKeyDown = useCallback(evt => {
    if (evt.key === 'Enter' && !evt.shiftKey) {
      evt.preventDefault();
      switchToCollabMode();
    }
  }, [switchToCollabMode]);
  if (layout === 'zoomed-out') {
    return null;
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(StyledOverflowActionCard, {
      onClick: () => {},
      disabled: true,
      $width: width,
      $height: height,
      $scale: 1,
      onMouseDown: event => {
        // Prevent panning the canvas when dragging within a card
        event.nativeEvent.stopImmediatePropagation();
        event.stopPropagation();
      },
      children: [/*#__PURE__*/_jsxs(StyledActionCardHeader, {
        $showIcon: true,
        children: [/*#__PURE__*/_jsx(StyledAiRibbon, {
          children: /*#__PURE__*/_jsx(AIBadge, {})
        }), /*#__PURE__*/_jsx(StyledAiActionWrapper, {
          children: /*#__PURE__*/_jsx(AiActionIcon, {
            size: 19
          })
        }), /*#__PURE__*/_jsx(StyledActionTypeHeader, {
          children: /*#__PURE__*/_jsx(Text, {
            typography: "heading-25",
            marginBlockStart: "0",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "collaborateGenerateActionsCard.label"
            })
          })
        })]
      }), /*#__PURE__*/_jsx(StyledActionCardBody, {
        $isDisabled: false,
        children: /*#__PURE__*/_jsx(AISendInput, {
          placeholder: I18n.text('collaborateGenerateActionsCard.promptPlaceholder'),
          value: prompt,
          onKeyDown: onKeyDown,
          onChatInputChanged: event => setPrompt(event.target.value),
          onSend: switchToCollabMode,
          shrink: false,
          minHeight: COPILOT_PROMPT_HEIGHT,
          maxHeight: COPILOT_PROMPT_HEIGHT
        })
      })]
    }), /*#__PURE__*/_jsx(FakeConnector, {
      children: "\xA0"
    })]
  });
};
export default CollaborationGenActionsNode;